// Real token/chain logos via the Trust Wallet assets CDN — the same public, no-key source used
// by most wallets and explorers. Falls back to null when there's no known mapping; callers should
// render a colored-initial placeholder in that case (and on image load failure).
import { getAddress } from 'ethers';

const TW = 'https://cdn.jsdelivr.net/gh/trustwallet/assets@master/blockchains/';

// Trust Wallet's per-chain folder name (used for both native "info/logo.png" and per-token
// "assets/<address>/logo.png" lookups).
export const TW_FOLDER = {
  Ethereum: 'ethereum', 'BNB Chain': 'smartchain', Polygon: 'polygon', Arbitrum: 'arbitrum',
  Optimism: 'optimism', Base: 'base', Avalanche: 'avalanchec',
  Tron: 'tron', Solana: 'solana', Bitcoin: 'bitcoin',
};

// Native-coin symbol -> folder, for chains where the "native" symbol doesn't match the chain's
// own TW_FOLDER key (e.g. Arbitrum/Optimism/Base all use plain ETH).
const NATIVE_FOLDER = {
  ETH: 'ethereum', BNB: 'smartchain', POL: 'polygon', MATIC: 'polygon', AVAX: 'avalanchec',
  BTC: 'bitcoin', SOL: 'solana', TRX: 'tron',
};

export function tokenLogoUrl(chain, token) {
  if (token.logo) return token.logo; // server already resolved one (custom-token add path)
  if (token.type === 'NATIVE' || !token.contract) { // no contract == the chain's native coin
    const f = NATIVE_FOLDER[token.symbol];
    return f ? `${TW}${f}/info/logo.png` : null;
  }
  const f = TW_FOLDER[chain];
  if (!f || !token.contract) return null;
  if (chain === 'Tron' || chain === 'Solana') return `${TW}${f}/assets/${token.contract}/logo.png`;
  try { return `${TW}${f}/assets/${getAddress(token.contract)}/logo.png`; } catch { return null; }
}

export function chainLogoUrl(chain) {
  const f = TW_FOLDER[chain];
  return f ? `${TW}${f}/info/logo.png` : null;
}
